import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "support-card" }
const _hoisted_2 = { class: "support-card__header" }
const _hoisted_3 = { class: "support-card__content" }
const _hoisted_4 = { class: "support-card__summary" }
const _hoisted_5 = { class: "support-card__heading" }
const _hoisted_6 = {
  key: 0,
  class: "support-card__item-list"
}
const _hoisted_7 = { class: "support-card__item-list-items" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 2,
  class: "support-card__item-list support-card__item-list--sub"
}
const _hoisted_11 = { class: "support-card__item-list-items" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 1,
  class: "support-card__item-list"
}
const _hoisted_15 = { class: "support-card__item-list-items" }
const _hoisted_16 = ["href"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 2,
  class: "support-card__item-list support-card__item-list--sub"
}
const _hoisted_19 = { class: "support-card__item-list-items" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 2,
  class: "support-card__item-list"
}
const _hoisted_23 = { class: "support-card__item-list-items" }
const _hoisted_24 = {
  key: 0,
  class: "support-card__item-list-item support-card__item-list-item--external"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://app.gitbook.com/o/yopOHsDRsBst8DT9oIRY/s/6U0Pq8qmhZ0b47iYaBG7/new-features",
  target: "_blank",
  class: "support-card__item-link"
}, [
  /*#__PURE__*/_createElementVNode("span", null, " New features ")
], -1 /* HOISTED */)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "support-card__item-list-item support-card__item-list-item--arrow" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, " Bug report ", -1 /* HOISTED */)
const _hoisted_29 = { class: "support-card__item-list-item support-card__item-list-item--arrow" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", null, " Feature request ", -1 /* HOISTED */)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TabNavigationComponent = _resolveComponent("TabNavigationComponent")
  const _component_router_link = _resolveComponent("router-link")
  const _component_SlideshowModalComponent = _resolveComponent("SlideshowModalComponent")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["support-card__icon", 'support-card__icon--' + $props.icon])
        }, null, 2 /* CLASS */),
        ($props.showVisibilityToggle)
          ? (_openBlock(), _createBlock(_component_TabNavigationComponent, {
              key: 0,
              tabs: $data.visibilities,
              "active-tab": $data.active_visibility,
              "no-margin": true,
              onSetTab: $options.setVisibility
            }, null, 8 /* PROPS */, ["tabs", "active-tab", "onSetTab"]))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("h2", _hoisted_5, _toDisplayString($props.title), 1 /* TEXT */),
            ($options.filtered_slideshows.length)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filtered_slideshows, (slideshow, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: `slideshow-${index}`,
                        class: "support-card__item-list-item support-card__item-list-item--arrow"
                      }, [
                        (slideshow.slideshow_url)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "support-card__item-link",
                              onClick: $event => ($data.active_slideshow = slideshow)
                            }, [
                              _createElementVNode("span", null, _toDisplayString(slideshow.title), 1 /* TEXT */)
                            ], 8 /* PROPS */, _hoisted_8))
                          : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(slideshow.title), 1 /* TEXT */)),
                        (slideshow.children && slideshow.children.length)
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filterChildren( slideshow.children ), (child_slideshow, i) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: `slideshow-child-${index}-${i}`,
                                    class: "support-card__item-list-item support-card__item-list-item--arrow"
                                  }, [
                                    (child_slideshow.slideshow_url)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          class: "support-card__item-link",
                                          onClick: $event => ($data.active_slideshow = slideshow)
                                        }, [
                                          _createElementVNode("span", null, _toDisplayString(child_slideshow.title), 1 /* TEXT */)
                                        ], 8 /* PROPS */, _hoisted_12))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(child_slideshow.title), 1 /* TEXT */))
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ])
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            ($options.filtered_links.length)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filtered_links, (link, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: `link-${index}`,
                        class: "support-card__item-list-item support-card__item-list-item--external"
                      }, [
                        (link.gitbook_page_url)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: link.gitbook_page_url,
                              target: "_blank",
                              class: "support-card__item-link"
                            }, [
                              _createElementVNode("span", null, _toDisplayString(link.title), 1 /* TEXT */)
                            ], 8 /* PROPS */, _hoisted_16))
                          : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(link.title), 1 /* TEXT */)),
                        (link.children && link.children.length)
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_18, [
                              _createElementVNode("div", _hoisted_19, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filterChildren( link.children ), (child_link, i) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: `link-child-${index}-${i}`,
                                    class: "support-card__item-list-item support-card__item-list-item--external"
                                  }, [
                                    (child_link.gitbook_page_url)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          href: child_link.gitbook_page_url,
                                          target: "_blank",
                                          class: "support-card__item-link"
                                        }, [
                                          _createElementVNode("span", null, _toDisplayString(child_link.title), 1 /* TEXT */)
                                        ], 8 /* PROPS */, _hoisted_20))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(child_link.title), 1 /* TEXT */))
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ])
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            ($props.isDevelopmentCard)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    ($data.active_visibility === 'staff')
                      ? (_openBlock(), _createElementBlock("li", _hoisted_24, _hoisted_26))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("li", _hoisted_27, [
                      _createVNode(_component_router_link, {
                        to: {
										name: 'support__bug-report'
									},
                        class: "support-card__item-link"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_28
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _createElementVNode("li", _hoisted_29, [
                      _createVNode(_component_router_link, {
                        to: {
										name: 'support__feature-request'
									},
                        class: "support-card__item-link"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_30
                        ]),
                        _: 1 /* STABLE */
                      })
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          ($data.active_slideshow)
            ? (_openBlock(), _createBlock(_component_SlideshowModalComponent, {
                key: 0,
                slideshow: $data.active_slideshow,
                onCloseModal: _cache[0] || (_cache[0] = $event => ($data.active_slideshow = null))
              }, null, 8 /* PROPS */, ["slideshow"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ]))
  ], 64 /* STABLE_FRAGMENT */))
}